import React from "react";

/**
 * Renders information about the user obtained from MS Graph
 * @param props 
 */
export const ProfileData = (props) => {
    // Minimal styling for profile data items
    const styles = {
        profileContainer: {
            textAlign: 'left',
            fontSize: '0.9rem',
        },
        profileItem: {
            margin: '8px 0',
            color: '#555',
        },
        label: {
            fontWeight: '600',
            color: '#444',
        }
    };

    return (
        <div style={styles.profileContainer}>
            <p style={styles.profileItem}>
                <span style={styles.label}>First Name: </span> 
                {props.graphData.givenName}
            </p>
            <p style={styles.profileItem}>
                <span style={styles.label}>Last Name: </span> 
                {props.graphData.surname}
            </p>
            <p style={styles.profileItem}>
                <span style={styles.label}>Email: </span> 
                {props.graphData.userPrincipalName}
            </p>
            <p style={styles.profileItem}>
                <span style={styles.label}>Id: </span> 
                {props.graphData.id}
            </p>
        </div>
    );
};